// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"FileImage_imageWrapper__1VBlm","image":"FileImage_image__3Cy36","deleteIcon":"FileImage_deleteIcon__2T0Yq"};